import * as React from "react"
import type { SVGProps } from "react"
const SvgTrendingUpMini = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M1.32 12.17a.96.96 0 0 1-.04-1.4l3.27-3.22q.59-.58 1.38-.58.8 0 1.39.58l1.15 1.13 2.7-2.71h-.79q-.4 0-.69-.3A1 1 0 0 1 9.4 5q0-.4.29-.7t.7-.29h3.16q.4 0 .7.29.28.29.28.7v3.14q0 .4-.28.7-.3.29-.7.29t-.7-.29a1 1 0 0 1-.28-.68v-.8l-2.72 2.72q-.59.58-1.38.58-.8 0-1.39-.58L5.93 8.92 2.7 12.17a.95.95 0 0 1-1.38 0" />
  </svg>
)
export default SvgTrendingUpMini
